<template>
  <div>
    <v-container class="content-wrapper" fluid id="add-provider-tab">
      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <v-row align="center">
              <v-col cols="12" md="auto">
                <v-btn
                  depressed
                  rounded
                  medium
                  color="primary200"
                  class="white--text font-weight-bold"
                  :to="{ name: 'Dashboard' }"
                >
                  <v-icon color="black" small class="mr-2">
                    mdi-arrow-left
                  </v-icon>
                  Back to Dashboard
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" class="neutral--text text-semi-bold mb-4">
                {{ $t('add-equipment-info') }}
              </v-col>
            </v-row>
            <div>
              <h5>
                {{ $t('your-progress') }}
              </h5>
              <label class="text-bold primary300--text"
                >{{ tab + 1 }}/{{ totalTabs }} {{ $t('to-complete') }}</label
              >
              <v-progress-linear
                v-model="progress"
                color="primary300"
                id="equipment-progress-bar"
                class="mb-4 mt-4"
                height="25"
              ></v-progress-linear>
            </div>

            <!-- Tabs for Add Provider -->
            <v-tabs
              v-model="tab"
              show-arrows
              active-class="primary200--text"
              class="disable-transition"
            >
              <v-tabs-slider color="primary200"></v-tabs-slider>
              <v-tab>{{ $t('basic') }}</v-tab>
              <v-tab>{{ $t('detailed') }}</v-tab>
              <v-tab>{{ $t('classification') }}</v-tab>
              <v-tab>{{ $t('contact') }}</v-tab>
              <v-tab>{{ $t('location') }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item :transition="false" :reverse-transition="false" :key="0">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddProviderBasicInfo
                      @tab="changeTab"
                      @providerBasicInfo="handleProviderBasicInfo"
                    ></AddProviderBasicInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="1">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddProviderDetailedInfo
                      @tab="changeTab"
                      @providerDetailedInfo="handleProviderDetailedInfo"
                    ></AddProviderDetailedInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="2">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddProviderClassificationInfo
                      @tab="changeTab"
                      @providerClassificationInfo="handleProviderClassificationInfo"
                    ></AddProviderClassificationInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="3">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddProviderContactInfo
                      @tab="changeTab"
                      @providerContactInfo="handleProviderContactInfo"
                    ></AddProviderContactInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="4">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddProviderLocationInfo
                      @tab="changeTab"
                      @providerLocationInfo="handleProviderLocationInfo"
                    ></AddProviderLocationInfo>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center mb-10" v-if="dataForPayload">
                  <v-btn
                    depressed
                    rounded
                    x-large
                    width="450px"
                    color="black"
                    @click="submit"
                    class="white--text font-weight-bold"
                    >{{ $t('submit') }}
                  </v-btn>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AddProviderBasicInfo from './AddProviderBasicInfo.vue';
import AddProviderDetailedInfo from './AddProviderDetailedInfo.vue';
import AddProviderClassificationInfo from './AddProviderClassificationInfo.vue';
import AddProviderContactInfo from './AddProviderContactInfo.vue';
import AddProviderLocationInfo from './AddProviderLocationInfo.vue';
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';

export default {
  name: 'AddProvider',
  mixins: [util],
  components: {
    AddProviderBasicInfo,
    AddProviderDetailedInfo,
    AddProviderClassificationInfo,
    AddProviderContactInfo,
    AddProviderLocationInfo,
  },
  data() {
    return {
      tab: null,
      totalTabs: 5,
      providerBasicInfo: Object,
      providerDetailedInfo: Object,
      providerClassificationInfo: Object,
      providerContactInfo: Object,
      providerLocationInfo: Object,
    };
  },
  computed: {
    progress() {
      return ((this.tab + 1) / this.totalTabs) * 100;
    },
    dataForPayload() {
      return Object.keys(this.providerLocationInfo).length > 0;
    },
  },
  methods: {
    changeTab(childTab) {
      console.log('Tab changed');

      this.tab = childTab;
    },
    handleProviderBasicInfo(data) {
      this.providerBasicInfo = data;
    },
    handleProviderDetailedInfo(data) {
      this.providerDetailedInfo = data;
    },
    handleProviderClassificationInfo(data) {
      this.providerClassificationInfo = data;
    },
    handleProviderContactInfo(data) {
      this.providerContactInfo = data;
    },
    handleProviderLocationInfo(data) {
      this.providerLocationInfo = data;
    },
    submit() {
      const payload = {
        ...this.providerBasicInfo,
        ...this.providerDetailedInfo,
        ...this.providerClassificationInfo,
        ...this.providerContactInfo,
        ...this.providerLocationInfo,
      };

      console.log('Payload Body', payload);

      this.axios
        .post('/api/v1/provider-settings', payload)
        .then(response => {
          console.log('Success:', response.data);
          EventBus.$emit('snackbar', {
            text: 'Provider Created Successfully',
            color: 'primary200',
          });

          const firstTime = sessionStorage.getItem('firstTime');

          if (!firstTime) {
            this.$router.push({ name: 'Dashboard' }).then(() => {
              window.location.reload();
            });
          } else {
            const providerId = Number(localStorage.getItem('providerId'));
            sessionStorage.setItem('providerId', providerId);

            this.$router.push({ name: 'Dashboard' }).then(() => {
              this.$router.go();
            });
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
    },
  },
};
</script>
